import '~/js/sections/weddings/includes/stickyNav';
import '~/js/libs/jquery-ui.selectmenu.min.js';
import 'slick-carousel';
import '~/js/libs/jquery.waypoint';
import '~/js/libs/sticky';
import '~/js/sections/weddings/includes/scroll-below';
import SocialShare from '~/js/modules/share-social';
import resortLocationsList from '~/js/sections/weddings/includes/locations-list.js';
// import locationSlideList from '~/js/sections/weddings/includes/locations-slide-list';
import 'slick-carousel';


// //////////////////////////Venues Slider///////////////////////////////////

require('~/js/libs/jquery-ui.selectmenu.min');
const instagramDots = require('~/js/sections/weddings/includes/navDots');
let pageOffsetY;
const cdnURL = '//cdn.sandals.com/beaches/v12';


const locationGallery = (clickTarget) => {
  let target;
  const modalOverlay = document.getElementById('modalOverlayLocations');
  const injectTarget = document.getElementById('injectTargetModal');
  const imageArray = [];

  modalOverlay.classList.add('show');
  document.body.classList.add('noScrollY');

  if (!clickTarget.classList.contains('.small-locations-container')) {
    target = $(clickTarget).closest('.small-locations-container')[0];
  } else {
    target = clickTarget;
  }

  const targetResort = target.getAttribute('data-resort');
  const locationsContainer = document.querySelector(`.locations-container[data-resort=${targetResort}]`);

  if (locationsContainer) {
    locationsContainer.classList.add('display');
  } else {
    const imageDirectory = `//cdn.sandals.com/beaches/v12/images/weddings/locations/${targetResort}/`;
    const resortObject = resortLocationsList[targetResort];

    resortObject.images.forEach((image, index) => {
      if (index === 0) {
        imageArray.push(`<img class='active object-fit' src=${imageDirectory}${image}>`);
      } else {
        imageArray.push(`<img class='object-fit' src=${imageDirectory}${image}>`);
      }
    });

    const injectHTML = document.createElement('div');

    let ogDescription = $("meta[property='og:description']").attr('content');
    let ogImg = $("meta[property='og:image']").attr('content');

    if (ogDescription === undefined) {
      ogDescription = 'Beaches Resorts';
    }
    if (ogImg === undefined) {
      ogImg = '//cdn.sandals.com/beaches/v11/site-elements/general/beaches_preview_images_new.png';
    }
    const linkFacebook = 'https://www.facebook.com/sharer.php?s=100&p[url]=https://www.beaches.com' + location.pathname + '&p[images][0]=' + ogImg + '&p[summary]=' + ogDescription;


    injectHTML.classList.add('locations-container');
    injectHTML.classList.add(resortObject.country.toLowerCase().replace(/\s/g, ''));
    injectHTML.classList.add('display');
    injectHTML.classList.add('container');
    injectHTML.setAttribute('data-resort', targetResort);
    injectHTML.innerHTML = `
        <div class='closeModal'>
              <div class = 'crossSign'>
                <div class="crosssign_circle"></div>
                <div class="crosssign_stem"></div>
                <div class="crosssign_stem2"></div>
              </div>
        </div>
        <div class='locs col-xs-12 noPadding'>
            <div class='resortSlides col-xs-12 noPadding'>
                <div class='image-wrap'>
                    ${imageArray.join('')}
                </div>
            </div>
            <div class = 'sliderDots'>
            </div>
            
            <div class='locations-details col-xs-12 noPadding'>
                <div class='location-title'>
                    <h3>${resortObject.name} - <span>${resortObject.city}, ${resortObject.country}</span></h3>
                </div>
                <div class="shareAndDownload">
                  <span class="downBtn">Download</span>
                  <a href='#' class="info__slider-controls-link js-download">
                    <i class="ic icon-download"></i>
                  </a>

                  <span>Share:</span>
                  <a class="share-facebook" href=${linkFacebook} target="_blank" style="display: inline-block !important;">
                    <i class="ic icon-facebook"></i>
                  </a>

                  <a href="http://www.pinterest.com/pin/create/button/?url=https://www.beaches.com/weddings/venues/&media=http:${cdnURL}/images/weddings/locations/${targetResort}/${targetResort}-01.jpg&description=Beaches%20Resorts%20Weddings%20%7C%Beaches%20${resortObject.name}" rel='nofollow' class="js-share-pinterest" data-pin-custom='true' target='_blank'><i class="ic icon-pinterest"></i></a>
                </div>
            </div>
        </div>
        `;
    $(injectTarget).append(injectHTML);


    const closeButton = document.querySelector(`.locations-container[data-resort=${targetResort}] .closeModal`);

    closeButton.onclick = () => {
      document.body.classList.remove('noScrollY');
      document.documentElement.scrollTop = document.body.scrollTop = pageOffsetY;
      modalOverlay.classList.remove('show');
      document.querySelector(`.locations-container[data-resort=${targetResort}]`).classList.remove('display');
    };

    const $slickSlider = $(`.locations-container[data-resort=${targetResort}] .image-wrap`);
    const settings = {
      dots: true,
      appendDots: $(`.locations-container[data-resort=${targetResort}] .sliderDots`),
      autoplay: true,
      autoplaySpeed: 5000
    };


    $slickSlider.on('init reInit afterChange', (e, slick, currentSlide) => {
      const i = (currentSlide ? currentSlide : 0) + 1;
      const pinterest = document.querySelector(`.locations-container[data-resort=${targetResort}] .js-share-pinterest`);

      const currentImage = $(slick.$slides[i - 1]).find('img').attr('src');
      // console.log(currentImage);

      const downloadButton = document.querySelector('.js-download');
      // console.log(downloadButton);

      downloadButton.setAttribute('download', currentImage);

      const currentImageName = currentImage.split('/')[currentImage.split('/').length - 1];

      // $(`.locations-container[data-resort=${targetResort}] .slideCounterSlash`).text(i + '/' + slick.slideCount);

      // console.log(cdnURL, targetResort, currentImageName, resortObject.name);
      pinterest.setAttribute('href', `http://www.pinterest.com/pin/create/button/?url=https://www.beaches.com/weddings/venues/&media=http:${cdnURL}/images/weddings/locations/${targetResort}/${currentImageName}&description=Beaches%20Resorts%20Weddings%20%7C%20Beaches%20${resortObject.name}`);
    });

    $slickSlider.on('init', () => {
      const dotsWrap = document.querySelector(`.locations-container[data-resort=${targetResort}] .slick-dots`);
      const dots = Array.from(dotsWrap.querySelectorAll('li'));

      if (dots.length > 5) {
        dots.forEach((dot, index) => {
          if (index <= 2) {
            dot.classList.add('large');
          } else if (index === 3) {
            dot.classList.add('semi');
          } else if (index === 4) {
            dot.classList.add('small');
          } else {
            dot.classList.add('none');
          }
        });
        instagramDots(dotsWrap, $slickSlider);
      }
    });

    $slickSlider.slick(settings);

  }
};

$('.js-share-pinterest').on('click', (e) => {

  const ogDescription = 'Beaches Resorts Weddings';
  let activeImg = $('.weddings-top .slick-active').find('.slider-item-inner').css('backgroundImage').replace(/["'()]/g, '').replace('url', '');

  activeImg = `http://cdn.sandals.com/beaches/v12/images/weddings/locations/pinterest/${activeImg.split('/')[activeImg.split('/').length - 1]}`;

  const params = {
    link: 'http://www.beaches.com' + location.pathname,
    img: activeImg,
    title: ogDescription
  };
  const link = SocialShare.generateUrl('https://pinterest.com/pin/create/bookmarklet/?media={img}&url={link}&is_video={is_video}&description={title}', params);

  $('.js-share-pinterest').children().attr('href', link);
  SocialShare.doPopup(e, link);
});


document.onclick = (event) => {

  const target = event.target;

  if (!Element.prototype.matches) {
    if (target.webkitMatchesSelector) {
      target.matches = target.webkitMatchesSelector;
    }

    if (target.msMatchesSelector) {
      target.matches = target.msMatchesSelector;
    }

    if (target.mozMatchesSelector) {
      target.matches = target.mozMatchesSelector;
    }
  }

  if (target.matches('.locationTab') && !target.matches('.active')) {
    // showActiveTab(target);

    return false;
  }

  if (target.matches('.small-locations-container .beachVenueLink, .small-locations-container .beachVenueLink *')) {
    pageOffsetY = window.pageYOffset;
    locationGallery(target);

    return false;
  }


  return true;
};


// import '~/js/sections/weddings/includes/stickyNav';
// import '~/js/sections/weddings/includes/scroll-below';
// import SocialShare from '~/js/modules/share-social';
// import resortLocationsList from '~/js/sections/weddings/includes/locations-list.js';
// import locationSlideList from '~/js/sections/weddings/includes/locations-slide-list';
// import 'slick-carousel';

// /* eslint-disable */

// const slickSlider = require('~/js/sections/weddings/includes/slider-top');
// require('~/js/libs/jquery-ui.selectmenu.min');
// const instagramDots = require('~/js/sections/weddings/includes/navDots');
// const arrayOfResorts = [];
// const topSliderWrap = document.querySelector('.weddings-top .js-slick-slider-top');
// let counter = 0;
// const $resortSelect = $('#js-resort-select');
// let pageOffsetY;
// const cdnURL = '//cdn.sandals.com/beaches/v12';
// const pinterest = document.querySelector('.share-pinterest.forIntroHeader');
// const $sliderTop = $('.js-slick-slider-top');

// locationSlideList.resorts.forEach((location, index, array) => {
//   if (index !== 0) {
//     arrayOfResorts.push(`
//         <div class='slider-item'>
//             <div class='slider-item-inner progressive background' style='background-image: url(${location.img})' >
//                 <div class='slider-text'>
//                     <div class='weddings-box'>
//                         <i class="icon-logo-Beaches-new"></i> <span>Weddings</span>
//                     </div>
//                     <div class='title'>
//                         <h1>Locations</h1>
//                         <h4>Start your life together in paradise</h4>
//                     </div>
//                 </div>
//                 <div class='slider-location'>
//                     <span class="arrow-up"></span><span>${location.location}</span>
//                 </div>
//             </div>
//         </div>`);
//   }
//   counter++;
//   if (counter === array.length) {
//     $(topSliderWrap).append(arrayOfResorts.join(''));
//     slickSlider();
//     $($sliderTop).on('afterChange', (event, slick, currentSlide) => {
//       let currentSlideImage = slick.$slides[currentSlide].children[0].getAttribute('data-bg');
//       let imageName;
//       if (currentSlideImage === null) {
//         currentSlideImage = slick.$slides[currentSlide].children[0].style.backgroundImage;
//         imageName = currentSlideImage.split('/')[currentSlideImage.split('/').length - 1].replace('.jpg\")', '');
//       } else {
//         imageName = currentSlideImage.split('/')[currentSlideImage.split('/').length - 1].replace('.jpg', '');
//       }
//       pinterest.setAttribute('href', `http://www.pinterest.com/pin/create/button/?url=${window.location.href}&media=http:${cdnURL}/images/weddings/locations/pinterest/${imageName}.jpg&description=Beaches%20Resorts%20Weddings`);
//     });
//   }
// });

// const resortSelectHandler = (event, data) => {
//   if (data.item.value !== '') {

//     const allResorts = Array.from(document.getElementsByClassName('small-locations-container'));
//     const country = data.item.value;
//     const resortAvailable = document.getElementById('resortsAvailable');
//     let resortsNotSelected;

//     if (country === 'all') {
//       resortsNotSelected = [];
//       resortAvailable.innerHTML = '16 Resorts on the Caribbean\'s best beaches.';
//     } else {
//       resortsNotSelected = Array.from(document.querySelectorAll(`.small-locations-container:not([data-country=${country}])`));
//       const numberOfResorts = allResorts.length - resortsNotSelected.length;

//       resortAvailable.innerHTML = `${numberOfResorts} ${numberOfResorts === 1 ? 'Resort' : 'Resorts'} in <span>${country}</span>.`;
//     }


//     allResorts.forEach(resort => {
//       resort.classList.remove('hide');
//     });
//     resortsNotSelected.forEach(resort => {
//       resort.classList.add('hide');
//     });
//   }
//   $('.js-lazy').unveil(400);
// };

// $resortSelect.selectmenu({
//   appendTo: $resortSelect.parent(),
//   change: resortSelectHandler
// });

// // const weddingActiveTabCover = document.querySelector('.weddingTabs .activeTabNav');
// // const weddingActiveTab = document.querySelector('.weddingTabs li.active');

// // weddingActiveTabCover.style.width = `${weddingActiveTab.offsetWidth}px`;
// // weddingActiveTabCover.style.left = `${weddingActiveTab.offsetLeft}px`;

// // const showActiveTab = (target) => {
// //     const newActive = target;
// //     const country = target.getAttribute('data-country');
// //     const allResorts = Array.from(document.getElementsByClassName('small-locations-container'));
// //     const countryName = target.innerText.toLowerCase();
// //     const resortAvailable = document.getElementById('resortsAvailable');
// //     let resortsNotSelected;

// //     if (country === 'all') {
// //         resortsNotSelected = [];
// //         resortAvailable.innerHTML = '16 Resorts on the Caribbean\'s best beaches.';
// //     } else {
// //         resortsNotSelected = Array.from(document.querySelectorAll(`.small-locations-container:not([data-country=${country}])`));
// //         const numberOfResorts = allResorts.length - resortsNotSelected.length;

// //         resortAvailable.innerHTML = `${numberOfResorts} ${numberOfResorts === 1 ? 'Resort' : 'Resorts'} in <span>${countryName}</span>.`;
// //     }

// //     allResorts.forEach(resort => {
// //         resort.classList.remove('hide');
// //     });
// //     resortsNotSelected.forEach(resort => {
// //         resort.classList.add('hide');
// //     });
// //     weddingActiveTabCover.style.left = `${newActive.offsetLeft}px`;
// //     document.querySelector('.weddingTabs li.active').classList.remove('active');
// //     newActive.classList.add('active');
// //     $('.js-lazy').unveil(400);
// // };

// // const weddingTabs = _.debounce(() => {
// //     weddingActiveTabCover.style.width = `${document.querySelector('.weddingTabs li.active').offsetWidth}px`;
// //     weddingActiveTabCover.style.left = `${document.querySelector('.weddingTabs li.active').offsetLeft}px`;
// // }, 300);

// // window.addEventListener('resize', weddingTabs);

// const locationGallery = (clickTarget) => {
//   let target;
//   const modalOverlay = document.getElementById('modalOverlayLocations');
//   const injectTarget = document.getElementById('injectTargetModal');
//   const imageArray = [];

//   modalOverlay.classList.add('show');
//   document.body.classList.add('noScrollY');

//   if (!clickTarget.classList.contains('.small-locations-container')) {
//     target = $(clickTarget).closest('.small-locations-container')[0];
//   } else {
//     target = clickTarget;
//   }

//   const targetResort = target.getAttribute('data-resort');
//   const locationsContainer = document.querySelector(`.locations-container[data-resort=${targetResort}]`);

//   if (locationsContainer) {
//     locationsContainer.classList.add('display');
//   } else {
//     const imageDirectory = `//cdn.sandals.com/beaches/v12/images/weddings/locations/${targetResort}/`;
//     const resortObject = resortLocationsList[targetResort];

//     resortObject.images.forEach((image, index) => {
//       if (index === 0) {
//         imageArray.push(`<img class='active object-fit' src=${imageDirectory}${image}>`);
//       } else {
//         imageArray.push(`<img class='object-fit' src=${imageDirectory}${image}>`);
//       }
//     });

//     const injectHTML = document.createElement('div');

//     injectHTML.classList.add('locations-container');
//     injectHTML.classList.add(resortObject.country.toLowerCase().replace(/\s/g, ''));
//     injectHTML.classList.add('display');
//     injectHTML.classList.add('container');
//     injectHTML.setAttribute('data-resort', targetResort);
//     injectHTML.innerHTML = `
//         <div class='locs col-xs-12 noPadding'>
//             <div class='locations-details col-xs-12 noPadding'>
//                 <div class='location-title'>
//                     <h3><i class='ic logo-beaches'></i>${resortObject.name}</h3>
//                     <h4>${resortObject.city}, ${resortObject.country}</h4>
//                 </div>
//                 <a href='${resortObject.link}'>View Resort<i class='ic icon-button-arrow-next'></i></a>
//                 <div class='closeModal'></div>
//             </div>
//             <div class='resortSlides col-xs-12 noPadding'>
//                 <a href='http://www.pinterest.com/pin/create/button/?url=https://www.beaches.com/weddings/venues/&media=http:${cdnURL}/images/weddings/locations/${targetResort}/${targetResort}-01.jpg&description=Beaches%20Resorts%20Weddings%20%7C%Beaches%20${resortObject.name}' rel='nofollow' class='share-pinterest' data-pin-custom='true' target='_blank'><i class='icon-pinterest'></i></a>
//                 <div class='image-wrap'>
//                     ${imageArray.join('')}
//                 </div>
//             </div>
//             <div class='locationSlideInfo col-xs-12 noPadding'>
//                 <span class='slideCounterSlash'><span class='index'>1</span>/${resortObject.images.length}</span>
//                 <span class='weddingLocationsText'>Wedding Locations</span>
//             </div>
//         </div>
//         `;
//     $(injectTarget).append(injectHTML);

//     const closeButton = document.querySelector(`.locations-container[data-resort=${targetResort}] .closeModal`);

//     closeButton.onclick = () => {
//       document.body.classList.remove('noScrollY');
//       document.documentElement.scrollTop = document.body.scrollTop = pageOffsetY;
//       modalOverlay.classList.remove('show');
//       document.querySelector(`.locations-container[data-resort=${targetResort}]`).classList.remove('display');
//     };

//     const $slickSlider = $(`.locations-container[data-resort=${targetResort}] .image-wrap`);
//     const settings = {
//       dots: true,
//       appendDots: $(`.locations-container[data-resort=${targetResort}] .locationSlideInfo`),
//       autoplay: true,
//       autoplaySpeed: 5000
//     };
//     $slickSlider.on('init reInit afterChange', (e, slick, currentSlide) => {
//       const i = (currentSlide ? currentSlide : 0) + 1;
//       const pinterest = document.querySelector(`.locations-container[data-resort=${targetResort}] .share-pinterest`);

//       const currentImage = $(slick.$slides[i - 1]).find('img').attr('src');

//       const currentImageName = currentImage.split('/')[currentImage.split('/').length - 1];

//       $(`.locations-container[data-resort=${targetResort}] .slideCounterSlash`).text(i + '/' + slick.slideCount);
//       pinterest.setAttribute('href', `http://www.pinterest.com/pin/create/button/?url=https://www.beaches.com/weddings/venues/&media=http:${cdnURL}/images/weddings/locations/${targetResort}/${currentImageName}&description=Beaches%20Resorts%20Weddings%20%7C%20Beaches%20${resortObject.name}`);
//     });

//     $slickSlider.on('init', () => {
//       const dotsWrap = document.querySelector(`.locations-container[data-resort=${targetResort}] .slick-dots`);
//       const dots = Array.from(dotsWrap.querySelectorAll('li'));

//       if (dots.length > 5) {
//         dots.forEach((dot, index) => {
//           if (index <= 2) {
//             dot.classList.add('large');
//           } else if (index === 3) {
//             dot.classList.add('semi');
//           } else if (index === 4) {
//             dot.classList.add('small');
//           } else {
//             dot.classList.add('none');
//           }
//         });
//         instagramDots(dotsWrap, $slickSlider);
//       }
//     });

//     $slickSlider.slick(settings);

//   }
// };

// $('.js-share-pinterest').on('click', (e) => {

//   const ogDescription = 'Beaches Resorts Weddings';
//   let activeImg = $('.weddings-top .slick-active').find('.slider-item-inner').css('backgroundImage').replace(/["'()]/g, '').replace('url', '');

//   activeImg = `http://cdn.sandals.com/beaches/v12/images/weddings/locations/pinterest/${activeImg.split('/')[activeImg.split('/').length - 1]}`;

//   const params = {
//     link: 'http://www.beaches.com' + location.pathname,
//     img: activeImg,
//     title: ogDescription
//   };
//   const link = SocialShare.generateUrl('https://pinterest.com/pin/create/bookmarklet/?media={img}&url={link}&is_video={is_video}&description={title}', params);

//   $('.js-share-pinterest').children().attr('href', link);
//   SocialShare.doPopup(e, link);
// });


// document.onclick = (event) => {
//   const target = event.target;
//   if (!Element.prototype.matches) {
//     if (target.webkitMatchesSelector) {
//       target.matches = target.webkitMatchesSelector;
//     }

//     if (target.msMatchesSelector) {
//       target.matches = target.msMatchesSelector;
//     }

//     if (target.mozMatchesSelector) {
//       target.matches = target.mozMatchesSelector;
//     }
//   }

//   if (target.matches('.locationTab') && !target.matches('.active')) {
//     showActiveTab(target);
//     return false;
//   }

//   if (target.matches('.small-locations-container, .small-locations-container *')) {
//     pageOffsetY = window.pageYOffset;
//     locationGallery(target);
//     return false;
//   }

//   return true;
// };
